// Module
var code = "<span title=\"{{row['facebook_category'] == null || row['facebook_category'] == ''\n    ? 'N/A' : row['facebook_category']}}\">{{row['facebook_category'] == null || row['facebook_category'] == ''\n    ? 'N/A' : row['facebook_category']}}</span>\n";
// Exports
module.exports = code;